import * as C from '../../../../../ui/common/CommonStyles';

import ReceiptInfoSection from './ui/receiptInfoSection';

import { Box, Button, Divider, Flex, Group, Pagination, Stack, Title } from '@mantine/core';
import ProcessHistoryTable from './ui/processHistoryTable';
import ProcessDetailModal from './ui/processDetailModal';
import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { IconChevronLeft } from '@tabler/icons-react';
import { buildSearchString } from '../../utils/buildSearchString';
import {
  useGetAiAgentAsCsDetail,
  useGetAiAgentAsCsProcessHistory,
} from '../../../../../../shared/apis/ai-agent/ascs/reactQueries';
import StatusBadge from '../../Common/ui/StatusBadge';

export default function AiAgentAsCsDetails() {
  const navigate = useNavigate();
  const { companyId, ascsId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';
  const [selectedProcessId, setSelectedProcessId] = useState<number | null>(null);
  const [page, setPage] = useState(1);
  const size = 10;

  const handleCloseProcessDetail = () => {
    setSelectedProcessId(null);
  };

  const { data: receiptDetails } = useGetAiAgentAsCsDetail({ id: Number(ascsId) });
  const { data: processHistory } = useGetAiAgentAsCsProcessHistory({ id: Number(ascsId), page, size });

  return (
    <div>
      <C.TitleBox>
        <div
          className="title"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          AS/CS 상세
          <StatusBadge status={receiptDetails?.result[0]?.receiptStatus} />
        </div>
      </C.TitleBox>
      <C.ListBox>
        <Stack gap="lg">
          <ReceiptInfoSection detail={receiptDetails?.result[0]} />
          <Divider />
          <Box>
            <Title order={3} size="1rem" fw={500} mb="sm">
              AS/CS이력
            </Title>
            <ProcessHistoryTable
              rows={processHistory?.result ?? []}
              totalCount={processHistory?.count ?? 0}
              page={page}
              size={size}
              isLoading={false}
              isError={false}
              onSelectProcess={setSelectedProcessId}
            />
            <Flex h="100%" justify="center" align="center">
              <Pagination
                total={Math.max(Math.ceil((processHistory?.count ?? 0) / size), 1)}
                value={page}
                onChange={setPage}
                disabled={false}
              />
            </Flex>
          </Box>
          <Group justify="center" mt="lg">
            <Button
              variant="default"
              onClick={() =>
                navigate(
                  `/admin/management/aiagent/company/${companyId}/ascs${buildSearchString({
                    companyName,
                  })}`,
                  { replace: true },
                )
              }
              leftSection={<IconChevronLeft size={16} />}
            >
              뒤로가기
            </Button>
          </Group>
          <ProcessDetailModal
            opened={selectedProcessId != null}
            selectedProcessId={selectedProcessId ?? 0}
            loading={false}
            error={false}
            onClose={handleCloseProcessDetail}
          />
        </Stack>
      </C.ListBox>
    </div>
  );
}
